import axios from '@/plugins/axios';
export function getTengxunCosBanner() {
  return axios.get('/tengxun/cos/banner');
}
export function delTengxunCosBanner(params) {
  return axios.post('/tengxun/cos/banner/del', {
    Path: params.Path
  });
}
